/* Avalon | Purchase options
   One-time / Subscribe toggle + quantity tiers with live pricing.
   Feeds the selected quantity + selling plan into the theme's existing product form
   so the theme's native Add to cart button handles the submit. */
(function () {
  if (customElements.get('avalon-purchase-options')) return;

  class AvalonPurchaseOptions extends HTMLElement {
    connectedCallback() {
      this.unitPrice = parseInt(this.dataset.unitPrice, 10) || 0; // cents
      this.currency = this.dataset.currency || 'USD';
      this.subscribeDiscount = parseFloat(this.dataset.subscribeDiscount) || 0;
      this.formId = this.dataset.formId || '';

      this.mode = 'onetime';

      this.modeButtons = Array.from(this.querySelectorAll('.avalon-po__mode'));
      this.tiers = Array.from(this.querySelectorAll('.avalon-po__tier'));

      try {
        this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: this.currency
        });
      } catch (e) {
        this.formatter = null;
      }

      this.modeButtons.forEach((btn) =>
        btn.addEventListener('click', () => this.setMode(btn.dataset.mode))
      );

      this.tiers.forEach((tier) => {
        const radio = tier.querySelector('.avalon-po__radio');
        tier.addEventListener('click', () => {
          if (radio) radio.checked = true;
          this.selectTier();
        });
        if (radio) radio.addEventListener('change', () => this.selectTier());
      });

      this.selectTier();
      this.renderPrices();
    }

    get form() {
      if (this.formId) {
        const byId = document.getElementById(this.formId);
        if (byId) return byId;
      }
      const section = this.closest('[id^="shopify-section-"]') || document;
      return section.querySelector('form[action*="/cart/add"]');
    }

    money(cents) {
      const amount = Math.round(cents) / 100;
      if (this.formatter) return this.formatter.format(amount);
      return '$' + amount.toFixed(2);
    }

    setMode(mode) {
      this.mode = mode;
      this.modeButtons.forEach((btn) => {
        const on = btn.dataset.mode === mode;
        btn.classList.toggle('is-selected', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      this.renderPrices();
      this.syncForm();
    }

    selectTier() {
      this.tiers.forEach((tier) => {
        const radio = tier.querySelector('.avalon-po__radio');
        tier.classList.toggle('is-selected', !!(radio && radio.checked));
      });
      this.syncForm();
    }

    renderPrices() {
      this.tiers.forEach((tier) => {
        const q = parseInt(tier.dataset.quantity, 10) || 1;
        const d = parseFloat(tier.dataset.discount) || 0;
        const subUnit = parseInt(tier.dataset.subPrice, 10) || 0; // Loop's real per-unit subscribe price
        const base = this.unitPrice * q;

        let price;
        if (this.mode === 'subscribe') {
          // Use Loop's real subscription price when available; otherwise fall back to the % setting.
          price = subUnit > 0 ? subUnit * q : base * (1 - this.subscribeDiscount / 100);
        } else {
          price = base * (1 - d / 100);
        }

        const priceEl = tier.querySelector('[data-po-price]');
        const compareEl = tier.querySelector('[data-po-compare]');
        if (priceEl) priceEl.textContent = this.money(price);
        if (compareEl) {
          if (price < base - 0.5) {
            compareEl.textContent = this.money(base);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
      });
    }

    selectedTier() {
      return (
        this.tiers.find((tier) => {
          const radio = tier.querySelector('.avalon-po__radio');
          return radio && radio.checked;
        }) || this.tiers[0]
      );
    }

    /* Write the chosen quantity + selling plan into the theme's product form. */
    syncForm() {
      const form = this.form;
      if (!form) return;

      const tier = this.selectedTier();
      const quantity = tier ? parseInt(tier.dataset.quantity, 10) || 1 : 1;

      // Quantity — update the existing input if present, otherwise add a hidden one.
      let qInput = form.querySelector('[name="quantity"]');
      if (!qInput) {
        qInput = document.createElement('input');
        qInput.type = 'hidden';
        qInput.name = 'quantity';
        form.appendChild(qInput);
      }
      if (String(qInput.value) !== String(quantity)) {
        qInput.value = quantity;
        qInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Selling plan — the selected tier's plan, present only when subscribing.
      let spInput = form.querySelector('input[name="selling_plan"]');
      const tierPlan = tier ? tier.dataset.sellingPlan : '';
      const wantPlan = this.mode === 'subscribe' && tierPlan ? tierPlan : '';
      if (wantPlan) {
        if (!spInput) {
          spInput = document.createElement('input');
          spInput.type = 'hidden';
          spInput.name = 'selling_plan';
          form.appendChild(spInput);
        }
        spInput.value = wantPlan;
      } else if (spInput) {
        spInput.value = '';
      }
    }
  }

  customElements.define('avalon-purchase-options', AvalonPurchaseOptions);
})();
